export const normalizeFiles = (files: any) => {
  if (!files) return [];
  if (Array.isArray(files)) return files;
  if (Array.isArray(files.rows)) return files.rows;
  return [];
};

export const mapFile = (f: any) => ({
  fileId: f.id,
  name: f.name,
  stream: f.path,
  type: f.type,
});